interface AssignConfirmStepProps {
    itemLabel: string;
    itemTypeLabel: string;
    patientName?: string;
    image?: { src: string; width: number; height: number };
}

export default function AssignConfirmStep({
    itemLabel,
    itemTypeLabel,
    patientName,
    image,
}: AssignConfirmStepProps) {
    return (
        <div>
            {image ? (
                <img
                    src={image.src}
                    alt=""
                    width={image.width}
                    height={image.height}
                    decoding="async"
                    className="mx-auto mb-5 h-56 w-auto object-contain"
                />
            ) : null}
            <p className="text-foreground">
                Você deseja enviar o {itemTypeLabel}{' '}
                <span className="font-semibold">{itemLabel}</span> para o paciente{' '}
                <span className="font-semibold">{patientName}</span>?
            </p>
        </div>
    );
}
